/**
 * JSON.parse that never throws: returns `fallback` when the input is not valid
 * JSON (or parses to null/undefined), so callers stay free of try/catch noise.
 */
export const safeParseJson = (value, fallback) => {
  try {
    const parsed = JSON.parse(value);
    return parsed ?? fallback;
  } catch (error) {
    return fallback;
  }
};
